import http from './http.service';

class TariffService {
    constructor() {
        this.$http = http;
        this.baseUrl = "/api/tariffs";
    }


    load(id) {
        if (!id) {
            throw new Error('Id is required');
        }

        return this.$http.get(`${this.baseUrl}/load/${id}`);
    }

    loadDetails(id) {
        if (!id) {
            throw new Error('Id is required');
        }

        return this.$http.get(`${this.baseUrl}/loadDetails/${id}`);
    }

    loadForCopy(id) {
        if (!id) {
            throw new Error('Id is required');
        }

        return this.$http.get(`${this.baseUrl}/loadForCopy/${id}`);
    }

    loadItemsNomenclature(validOnes, id) {
        return this.$http.get(`${this.baseUrl}/itemsNomenclature`, {
            params: {
                validOnes: validOnes,
                id: id,
            }
        })
    }

    create(model) {
        if (!model) {
            throw new Error('Model is required');
        }

        return this.$http.post(`${this.baseUrl}/createTariff`, model);
    }

    update(model) {
        if (!model) {
            throw new Error('Model is required');
        }

        return this.$http.put(`${this.baseUrl}/updateTariff`, model);
    }

    delete(id) {
        if (!id) {
            throw new Error('Id is required');
        }

        return this.$http.delete('/api/tariffs/deleteTariffEntity', { params: { id: id } });
    }

    checkLinks(tariffId, itemId) {
        return this.$http.get(`${this.baseUrl}/checkLinks`, {
            params: {
                tariffId: tariffId,
                itemId: itemId,
            }
        })
    }
}

export default new TariffService();
